import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { Row, Col, Typography, Radio, Modal, Button, AutoComplete, Input, Icon, message, Divider, Select, Breadcrumb } from "antd";
import {
	fetchCardDetailsApi,
	fetchLscCustomer,
	mergeCardsApi,
	linkCardApi,
	mergeCustomersApi,
	searchCustomersApi,
	sendLoginOTPApi,
	updateContactNumberApi,
	verifyOTPApi,
} from "utils/apiService";

import { countries as countryList } from "constants/CountryList";

import cardIllustrationBlue from "media/inaamCards.svg";
import cardIllustrationBlack from "media/cardIllustrationBlack.svg";
import pointsYellow from "media/pointsYellow.svg";
import pointsBlack from "media/pointsBlack.svg";
import mergeCardsLarge from "media/mergeCardsLarge.svg";
import mergeCardsSmall from "media/mergeCardsSmall.svg";
import assignCardLarge from "media/assignCardLarge.svg";
import assignCardSmall from "media/assignCardSmall.svg";
import mergeContactsLarge from "media/mergeContactsLarge.svg";
import mergeContactsSmall from "media/mergeContactsSmall.svg";
import updateContactLarge from "media/updateContactLarge.svg";
import updateContactSmall from "media/updateContactSmall.svg";
import phoneGreen from "media/phoneGreen.svg";
import phoneRed from "media/phoneRed.svg";
import avatarLarge from "media/avatarLarge.svg";
import avatarMed from "media/avatarMed.svg";
import changePhoneGif from "media/changephone.gif";
import mergePhoneGif from "media/mergephone.gif";
import mergeCardGif from "media/mergecard.gif";
import OtpInput from "react-otp-input";
import Loader from "components/Loader/Loader";

const { Text } = Typography;
const { Option } = AutoComplete;

const RowDetails = ({ status, phone, cardList, type }) => {
	return (
		<Row>
			{status === "new" && (
				<div style={{ marginTop: 32 }}>
					<Text style={{ fontSize: "16px", lineHeight: "24px", color: "#181818" }}>
						{type === "updateNumber"
							? "You’re changing to a new phone number"
							: type === "mergeNumber"
							? "You’re merging with already existing phone number"
							: "You’re assigning card to a new phone number"}
					</Text>
				</div>
			)}
			{phone && (
				<Row type="flex" align="middle" style={{ marginTop: 16 }}>
					<div>
						<img src={status === "old" ? phoneRed : phoneGreen} style={{ width: "48px", height: "48px", paddingRight: 12 }} alt={"Illustration"} />
					</div>
					<div>
						<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>Phone Number</Text>
						<br />
						<Text style={{ fontSize: "16px", lineHeight: "24px", color: "#181818", fontWeight: "bold" }}>
							{phone !== undefined && phone !== null && phone !== "" ? phone : "-"}
						</Text>
					</div>
				</Row>
			)}
			{cardList?.length !== 0 && (
				<div style={status === "new" ? { padding: 16, background: "#F2F2F2", borderRadius: 8, marginTop: 24, width: "100%" } : {}}>
					{status === "new" && <Text>Other Banat Al Nujoom Cards on this phone number</Text>}
					{cardList?.map((card) => (
						<Row type="flex" align="middle" style={{ marginTop: 16 }}>
							<Row type="flex" align="middle" style={{ flexGrow: 1 }}>
								<div>
									<img
										src={status !== "old" ? cardIllustrationBlack : cardIllustrationBlue}
										style={{ width: "48px", height: "48px", paddingRight: 12 }}
										alt={"Illustration"}
									/>
								</div>
								<div>
									<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
									Banat Al Nujoom Card
									</Text>
									<br />
									<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
										{card.card_no !== undefined && card.card_no !== null ? card.card_no : "-"}
									</Text>
								</div>
							</Row>
							<Row type="flex" align="middle" style={{ flexGrow: 1 }}>
								<div>
									<img
										src={status !== "old" ? pointsBlack : pointsYellow}
										style={{ width: "48px", height: "48px", paddingRight: 12 }}
										alt={"Illustration"}
									/>
								</div>
								<div>
									<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
									Banat Al Nujoom Points
									</Text>
									<br />
									<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
										{card.points !== undefined && card.points !== null ? card.points : "-"}
									</Text>
								</div>
							</Row>
						</Row>
					))}
				</div>
			)}
		</Row>
	);
};

const CardDetails = ({ cardNumber, cardPoints }) => {
	return (
		<Row type="flex" style={{ margin: "12px 0", flexGrow: 1 }}>
			<Row
				type="flex"
				align="middle"
				style={{
					paddingRight: 24,
				}}>
				<Col>
					<img src={cardIllustrationBlue} style={{ width: "52px", height: "52px", paddingRight: 10 }} alt={"Illustration"} />
				</Col>
				<Col>
					<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>Banat Al Nujoom Card</Text>
					<br />
					<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
						{cardNumber !== undefined && cardNumber !== null ? cardNumber : "-"}
					</Text>
				</Col>
			</Row>
			<Row
				type="flex"
				align="middle"
				style={{
					paddingRight: 24,
				}}>
				<Col>
					<img src={pointsYellow} style={{ width: "52px", height: "52px", paddingRight: 10 }} alt={"Illustration"} />
				</Col>
				<Col>
					<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>Banat Al Nujoom Points</Text>
					<br />
					<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
						{cardPoints !== undefined && cardPoints !== null ? cardPoints.toFixed(2) : "-"}
					</Text>
				</Col>
			</Row>
		</Row>
	);
};

const MergeActions = ({ icon, title, clickHandler, disableKey }) => {
	return (
		<div
			onClick={clickHandler}
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				padding: "16px 16px 24px",
				padding: 16,
				background: "#FFFFFF",
				border: "1px solid #F2F2F2",
				boxSizing: "border-box",
				boxShadow: "0px 4px 12px #F2F2F2",
				borderRadius: "10px",
				marginRight: 32,
				marginBottom: 32,
				opacity: disableKey ? 0.4 : 1,
				cursor: disableKey ? "not-allowed" : "pointer",
			}}>
			<img
				src={icon}
				style={{
					width: "200px",
					height: "150px",
					marginBottom: 16,
				}}
				alt={"Illustration"}
			/>
			<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>{title}</Text>
		</div>
	);
};

const ViewDetails = ({ icon, title, text, clickHandler }) => {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				padding: "16px 16px 24px",
				padding: 16,
				background: "#FFFFFF",
				border: "1px solid #F2F2F2",
				boxSizing: "border-box",
				boxShadow: "0px 4px 12px #F2F2F2",
				borderRadius: "10px",
				marginRight: 32,
				marginBottom: 32,
				width: 232,
				height: 180,
			}}>
			<Text style={{ fontSize: "16px", lineHeight: "24px", color: "#181818", fontWeight: "bold", display: "flex", alignItems: "center" }}>
				{icon}
				{title}
			</Text>
			<Text style={{ fontSize: "14px", lineHeight: "22px", color: "#747474", fontWeight: "bold", display: "flex", alignItems: "center" }}>
				{text}
			</Text>
			<Button
				style={{
					height: "32px",
					boxShadow: "none",
					borderRadius: "5px",
					border: "none",
					backgroundColor: "#fec708",
					color: "#FFFFFF",
				}}
				onClick={clickHandler}
				prefix={<Icon type="eye" style={{ color: "#FFFFFF" }} />}>
				{title}
			</Button>
		</div>
	);
};

const CustomerDetail = ({ ...props }) => {
	const [loading, setLoading] = useState(true);
	const [countryCode, setCountryCode] = useState(`${JSON.parse(localStorage.getItem("countryData"))?.isd_code}`);
	const [contactNumberLength, setContactNumberLength] = useState(JSON.parse(localStorage.getItem("countryData"))?.contact_number_length || 10);
	const [customerDetail, setCustomerDetail] = useState({
		country_code: "",
		contact_number: "",
		name: "",
		email: "",
		card_list: [],
	});

	// const [customerList, setCustomerList] = useState([]);

	const [mergeCardModal, setMergeCardModal] = useState(false);
	const [mergeCardConfirmPage, setMergeCardConfirmPage] = useState(0);
	const [selectedCard, setSelectedCard] = useState(null);

	const [updateNumberModal, setUpdateNumberModal] = useState(false);
	const [confirmPage, setConfirmPage] = useState(0);
	const [updateNumber, setUpdateNumber] = useState(null);
	const updateNumberRef = useRef(null);

	const [mergeNumberModal, setMergeNumberModal] = useState(false);
	const [mergeConfirmPage, setMergeConfirmPage] = useState(0);
	const [mergeNumber, setMergeNumber] = useState(null);
	const mergeNumberRef = useRef(null);

	const [assignCardModal, setAssignCardModal] = useState(false);
	const [assignConfirmPage, setAssignConfirmPage] = useState(0);
	const [assignNumber, setAssignNumber] = useState(null);
	const assignNumberRef = useRef(null);

	const [disableBtn, setDisableBtn] = useState(false);

	const { userType, country_code, customerID } = useParams();

	const [verifiedCustomer, setVerifiedCustomer] = useState(false);
	const [otp, setOTP] = useState();

	// const searchCustomer = (v) => {
	// 	searchCustomersApi({
	// 		requestData: {
	// 			// country_code: countryCode,
	// 			search_key: v,
	// 			type: "contact",
	// 		},
	// 		res200Callback: (res) => {
	// 			setCustomerList(res.data.search_results);
	// 		},
	// 	});
	// };

	const sendOTP = (contact) => {
		sendLoginOTPApi({
			requestData: {
				country_code: countryCode,
				contact_number: `${countryCode}${contact}`,
			},
			res200Callback: () => {
				message.info("OTP is sent to customer's contact number.");
			},
		});
	};

	// const renderOption = (item) => {
	// 	return (
	// 		<Option key={item.key} value={item.key}>
	// 			<Row type="flex" align="middle">
	// 				<img
	// 					src={item.type === "Contact Number" ? avatarMed : cardIllustrationBlack}
	// 					style={{
	// 						width: "36px",
	// 						height: "36px",
	// 						paddingRight: 16,
	// 					}}
	// 					alt={"Illustration"}
	// 				/>
	// 				<div style={{ display: "flex", flexDirection: "column", marginRight: 20 }}>
	// 					<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818" }}>{item.name}</Text>
	// 					<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px" }}>{item.key}</Text>
	// 				</div>
	// 			</Row>
	// 			{/* <Row type="flex" style={{ boxShadow: "inset 0px -1px 0px rgba(0, 0, 0, 0.05)" }}>
	// 				<div style={{ display: "flex", flexDirection: "column" }}>
	// 					<div style={{ display: "flex", alignItems: "center" }}>
	// 						<img
	// 							src={avatarMed}
	// 							style={{
	// 								width: "36px",
	// 								height: "36px",
	// 								paddingRight: 16,
	// 							}}
	// 							alt={"Illustration"}
	// 						/>
	// 						<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818" }}>
	// 							{item.name || "-"}
	// 						</Text>
	// 					</div>
	// 					<div style={{ display: "flex", margin: "16px 0" }}>
	// 						<div style={{ display: "flex", flexDirection: "column", marginRight: 20 }}>
	// 							<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "12px", lineHeight: "18px" }}>Phone Number</Text>
	// 							<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "14px", lineHeight: "22px", marginTop: "8px", color: "#181818" }}>
	// 								{item.contact_number}
	// 							</Text>
	// 						</div>
	// 						<div style={{ display: "flex", flexDirection: "column" }}>
	// 							<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "12px", lineHeight: "18px" }}>{`Banat Al Nujoom Card Number(s)`}</Text>
	// 							<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "14px", lineHeight: "22px", marginTop: "8px", color: "#181818" }}>
	// 								{item.inaam_card_list[0] || "-"} {item.inaam_card_list.length > 1 && `+ ${item.inaam_card_list.length - 1} more`}
	// 							</Text>
	// 						</div>
	// 					</div>
	// 				</div>
	// 			</Row> */}
	// 		</Option>
	// 	);
	// };

	useEffect(() => {
		if (otp?.length === 6) {
			verifyOTPApi({
				requestData: {
					country_code: countryCode,
					contact_number: `${countryCode}${
						assignConfirmPage === 1
							? assignNumber.contact_number
							: mergeConfirmPage === 1
							? mergeNumber.contact_number
							: confirmPage === 1
							? updateNumber.contact_number
							: null
					}`,
					otp: otp,
				},
				res200Callback: (res) => {
					res?.data.verified === true && mergeNumberModal && setVerifiedCustomer(true);
					res?.data.verified === true
						? (mergeNumberModal && setMergeConfirmPage(0)) || (updateNumberModal && setConfirmPage(2)) || (assignCardModal && setAssignConfirmPage(2))
						: message.error("Please enter correct OTP!");
				},
			});
		}
	}, [otp]);

	useEffect(() => {
		if (assignConfirmPage === 1 || mergeConfirmPage === 1 || confirmPage === 1) {
			setOTP(null);
			sendOTP(
				assignConfirmPage === 1
					? assignNumber.contact_number
					: mergeConfirmPage === 1
					? mergeNumber.contact_number
					: confirmPage === 1
					? updateNumber.contact_number
					: null
			);
		}
	}, [assignConfirmPage, confirmPage, mergeConfirmPage]);

	useEffect(() => {
		if (userType !== "card") {
			localStorage.getItem("verified") !==
				("+" + country_code + "-" + customerID)
					.split("")
					.reduce((a, b) => {
						a = (a << 5) - a + b.charCodeAt(0);
						return a & a;
					}, 0)
					.toString() && props.history.go(-1);
		}
	}, []);

	useEffect(() => {
		fetchCardDetailsApi({
			requestData: {
				// country_code: country_code,
				search_key: customerID,
				type: userType === "card" ? "Card Number" : "Contact Number",
			},
			res200Callback: (res) => {
				loading && setLoading(false);
				setCustomerDetail({ ...res.data.customer_details });
			},
		});
	}, []);

	return loading ? (
		<div
			style={{
				minHeight: "100vh",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: "#FAFAFA",
			}}>
			<Loader />
		</div>
	) : (
		<Row>
			<Text style={{ color: "#181818", /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "39px" }}>
				<Icon
					type="arrow-left"
					style={{
						height: "16px",
						paddingRight: "16px",
					}}
					onClick={() => props.history.go(-1)}
				/>
				Customer Details
			</Text>
			<Breadcrumb style={{ margin: "4px 0" }} separator={<span style={{ color: "#747474" }}>{"<"}</span>}>
				<Breadcrumb.Item
					style={{ /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
					<Link to={"/"}>Search Customer</Link>
				</Breadcrumb.Item>
				<Breadcrumb.Item
					style={{ /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#464646" }}>
					Customer Details
				</Breadcrumb.Item>
			</Breadcrumb>
			<Row
				type="flex"
				style={{
					flexWrap: "nowrap",
					background: "#FFFFFF",
					padding: "12px 24px 24px",
					border: "1px solid #F2F2F2",
					boxSizing: "border-box",
					boxShadow: "0px 4px 12px #F2F2F2",
					borderRadius: "10px",
					marginTop: "16px",
				}}>
				<div style={{ margin: `12px 45px ${customerDetail.card_list?.length > 1 ? "45px" : "0px"} 0` }}>
					<div style={{ display: "flex", alignItems: "center" }}>
						<img
							src={avatarLarge}
							style={{
								width: "80px",
								height: "80px",
							}}
							alt={"Illustration"}
						/>
						<div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", margin: "0 20px" }}>
							<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "40px", color: "#181818" }}>
								{!customerDetail.contact_number ? "No Owner" : customerDetail.name !== "" ? customerDetail.name : "Unknown User"}
							</Text>
							<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "16px", lineHeight: "24px" }}>
								{customerDetail.contact_number ? `${customerDetail.contact_number}` : "No Phone Number"}
							</Text>
						</div>
					</div>
				</div>
				{/* <Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "20px", lineHeight: "32px", color: "#181818" }}>
						Customer Banat Al Nujoom Cards
					</Text> */}
				<Row type="flex" align="middle" style={{ flexGrow: 1, flexWrap: "wrap" }}>
					{customerDetail.card_list?.map((card) => (
						<CardDetails cardNumber={card.card_no} cardPoints={card.points} />
					))}
				</Row>
			</Row>
			<Row style={{ display: "flex", flexDirection: "column", marginTop: 32 }}>
				<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "20px", lineHeight: "32px", color: "#181818" }}>
					Choose Action to Perform
				</Text>
				<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474", paddingBottom: 16 }}>
					Please select one option to Update / Merge Cards & Phone Numbers
				</Text>
				<Row type="flex">
					<MergeActions
						title="Change Phone Number"
						icon={updateContactLarge}
						disableKey={!customerDetail?.contact_number || customerDetail?.card_list?.length !== 1}
						clickHandler={() => (!customerDetail?.contact_number || customerDetail?.card_list?.length !== 1 ? null : setUpdateNumberModal(true))}
					/>
					<MergeActions
						title="Merge Phone Numbers"
						icon={mergeContactsLarge}
						disableKey={!customerDetail?.contact_number || customerDetail?.card_list?.length !== 1}
						clickHandler={() => (!customerDetail?.contact_number || customerDetail?.card_list?.length !== 1 ? null : setMergeNumberModal(true))}
					/>
					<MergeActions
						title="Merge Banat Al Nujoom Cards"
						icon={mergeCardsLarge}
						disableKey={!customerDetail?.contact_number || customerDetail?.card_list?.length <= 1}
						clickHandler={() => (!customerDetail?.contact_number || customerDetail?.card_list?.length <= 1 ? null : setMergeCardModal(true))}
					/>
					<MergeActions
						title="Assign Card"
						icon={assignCardLarge}
						disableKey={!!customerDetail?.contact_number}
						clickHandler={() => (!!customerDetail?.contact_number ? null : setAssignCardModal(true))}
					/>
				</Row>
				{/* <Row type="flex">
					<ViewDetails icon={<></>} title={"View Cards"} text={""} clickHandler={} />
					<ViewDetails icon={<></>} title={"View Transactions"} text={""} clickHandler={} />
					<ViewDetails icon={<></>} title={"View Vouchers"} text={"Find all of the cards in the Banat Al Nujoom & other system."} clickHandler={} />
				</Row> */}
			</Row>
			<Modal
				width={1000}
				centered
				visible={mergeCardModal}
				destroyOnClose
				maskClosable={false}
				closable={mergeCardConfirmPage !== 2}
				onCancel={() => {
					setMergeCardModal(false);
					setMergeCardConfirmPage(0);
					setSelectedCard(null);
				}}
				footer={null}>
				<Row className="modal-row">
					{mergeCardConfirmPage !== 2 && (
						<Row type="flex" align="middle">
							<img
								src={mergeCardsSmall}
								style={{
									width: "32px",
									height: "32px",
									marginRight: 16,
								}}
								alt={"Illustration"}
							/>
							<Text
								style={{
									fontWeight: "bold",
									color: "#181818",
									fontSize: "24px",
								}}>
								{mergeCardConfirmPage === 0 ? "Merge" : mergeCardConfirmPage === 1 ? "Confirm Merge" : "Merged"} Banat Al Nujoom Cards
							</Text>
						</Row>
					)}
					{mergeCardConfirmPage !== 2 && <Divider />}
					<Row style={{ marginTop: "24px" }}>
						<div style={{ display: "flex", flexDirection: "column" }}>
							{mergeCardConfirmPage !== 2 && (
								<Text
									style={{
										fontSize: "20px",
										color: "#181818",
										fontWeight: "bold",
										lineHeight: "32px",
										marginBottom: "16px",
									}}>
									{mergeCardConfirmPage === 0 ? "Select" : mergeCardConfirmPage === 1 && "Confirm"} Primary Banat Al Nujoom Card
								</Text>
							)}
							{mergeCardConfirmPage !== 2 && (
								<Text
									style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474", paddingBottom: 16 }}>
									Please note that the old number will get merged with the new number. Henceforth, the points of the card attached with the new number
									will get transferred to the card attached with the old number.
								</Text>
							)}
							<Row>
								{mergeCardConfirmPage === 1 ? (
									<CardDetails
										cardNumber={selectedCard}
										cardPoints={customerDetail?.card_list?.map((card) => card.points).reduce((sum, current) => sum + current, 0)}
									/>
								) : mergeCardConfirmPage === 0 ? (
									<Radio.Group
										onChange={(e) => setSelectedCard(e.target.value)}
										style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
										{customerDetail.card_list?.map((card) => (
											<Radio
												value={card.card_no}
												style={{
													display: "flex",
													alignItems: "center",
													border: "1px solid #F2F2F2",
													boxSizing: "border-box",
													borderRadius: "8px",
													paddingLeft: 12,
												}}>
												<CardDetails cardNumber={card.card_no} cardPoints={card.points} />
											</Radio>
										))}
									</Radio.Group>
								) : (
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											background: "#FFFFFF",
											width: "100%",
											padding: 16,
											marginTop: 24,
										}}>
										<img
											src={mergeCardGif}
											style={{
												width: "160px",
												height: "160px",
												borderRadius: "100px",
											}}
											alt={"Illustration"}
										/>
										<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "32px", color: "#181818", marginTop: 16 }}>
										Banat Al Nujoom cards have been merged successfully
										</Text>
										<Text
											style={{
												fontStyle: "normal",
												fontWeight: "normal",
												fontSize: "14px",
												lineHeight: "22px",
												marginTop: 16,
												textAlign: "center",
												padding: "0 76px",
											}}>
											Please inform customer that they must log out and log in to the Banat Al Nujoom App to view the changes.
										</Text>
									</div>
								)}
							</Row>
						</div>
						<Divider />
						<Row
							style={{
								textAlign: mergeCardConfirmPage !== 2 ? "right" : "center",
							}}>
							{mergeCardConfirmPage !== 2 && (
								<Button
									size="large"
									style={{
										height: "40px",
										boxShadow: "none",
										borderRadius: "5px",
										border: "none",
										backgroundColor: "#FFFFFF",
										color: "#181818",
										marginRight: "16px",
									}}
									onClick={() => {
										setMergeCardModal(false);
										setSelectedCard(null);
										setMergeCardConfirmPage(0);
									}}>
									Cancel
								</Button>
							)}
							<Button
								disabled={!selectedCard || disableBtn}
								size="large"
								style={{
									height: "40px",
									borderRadius: "5px",
									border: "none",
									backgroundColor: "#fec708",
									color: "#FFFFFF",
									opacity: !selectedCard || disableBtn ? 0.4 : 1,
								}}
								onClick={() => {
									if (mergeCardConfirmPage === 0) {
										setMergeCardConfirmPage(1);
									} else if (mergeCardConfirmPage === 1) {
										setDisableBtn(true);
										mergeCardsApi({
											requestData: {
												contact_number: customerDetail.contact_number,
												country_code: customerDetail.country_code,
												old_card_details: customerDetail.card_list,
												new_card_details: [
													{
														card_no: selectedCard,
														points: customerDetail?.card_list?.map((card) => card.points).reduce((sum, current) => sum + current, 0),
													},
												],
											},
											resCallback: () => setDisableBtn(false),
											res200Callback: () => {
												message.success("Banat Al Nujoom Cards Merged Successfully.");
												setMergeCardConfirmPage(2);
											},
										});
									} else {
										props.history.go(0);
									}
								}}>
								{mergeCardConfirmPage === 0 ? "Continue" : mergeCardConfirmPage === 1 ? "Confirm Update" : "Back to Home"}
							</Button>
						</Row>
					</Row>
				</Row>
			</Modal>
			<Modal
				width={confirmPage === 0 ? 450 : confirmPage === 1 ? 522 : confirmPage === 2 ? 580 : 660}
				centered
				visible={updateNumberModal}
				closable={confirmPage !== 3}
				destroyOnClose
				maskClosable={false}
				onCancel={() => {
					setUpdateNumberModal(false);
					setConfirmPage(0);
					setUpdateNumber(null);
				}}
				footer={null}>
				<Row className="modal-row">
					{confirmPage !== 3 && (
						<Row type="flex" align="middle">
							<img
								src={updateContactSmall}
								style={{
									width: "32px",
									height: "32px",
									marginRight: 16,
								}}
								alt={"Illustration"}
							/>
							<Text
								style={{
									fontWeight: "bold",
									color: "#181818",
									fontSize: "24px",
								}}>
								{confirmPage === 0 ? "Change" : confirmPage === 1 ? "Verify" : confirmPage === 2 ? "Confirm" : "Changed"} Phone Number
							</Text>
						</Row>
					)}
					{confirmPage !== 3 && <Divider />}
					<Row style={{ marginTop: "24px" }}>
						<div>
							{confirmPage !== 3 && (
								<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
									Please note that the card linked with the old number will get linked to the new number once you proceed with this operation. The old
									number will not have any card(s) linked with it.
								</Text>
							)}
							{confirmPage === 0 ? (
								<div style={{ display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 16 }}>
									<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "14px", lineHeight: "22px", color: "#181818" }}>
										New Phone Number
									</Text>
									<div style={{ display: "flex", alignItems: "center" }}>
										<Select
											showSearch
											allowClear
											style={{
												display: "flex",
												alignItems: "center",
												margin: "8px 16px 0 0",
												// padding: "8px 8px",
												justifyContent: "space-between",
												width: 200,
												border: "1px solid #D9D9D9",
												borderRadius: "5px",
												height: "48px",
												textOverflow: "ellipsisis",
											}}
											defaultValue={countryCode}
											placeholder="Country Code"
											optionFilterProp="children"
											onChange={(value) => setCountryCode(value)}
											disabled={true}
											filterOption={(input, option) => option.props.children.indexOf(input) >= 0}>
											{countryList.map((country) => (
												<Option key={country.phone} value={country.phone}>
													{country.emoji} {`${country.shortName} (+${country.phone})`}
												</Option>
											))}
										</Select>
										<AutoComplete
											dropdownStyle={{ width: 250, border: "1px solid #D9D9D9", borderRadius: "5px" }}
											size="large"
											style={{ width: "100%", height: 48, marginTop: 8 }}
											onSearch={(str) => {
												updateNumberRef.current = str;
												str.length === contactNumberLength
													? fetchLscCustomer({
															requestData: {
																country_code: countryCode,
																contact_number: updateNumberRef.current,
															},
															res200Callback: (res) => {
																if (!res.data.account_exists) {
																	// if (res.data.customer_details?.card_list?.length === 0) {
																	setUpdateNumber({ ...customerDetail, contact_number: updateNumberRef.current });
																	message.info("The entered number will be the new phone number.");
																} else {
																	message.error("This user already exists, please proceed to merge customers.");
																}
																// else message.error("This number already has Banat Al Nujoom Cards, please proceed to merge customers.");
															},
															resErrorCallback: () => {
																setUpdateNumber({ ...customerDetail, contact_number: updateNumberRef.current });
																message.info("The entered number will be the new phone number.");
															},
													  })
													: setUpdateNumber(null);
											}}
											optionLabelProp="value"
											// dataSource={customerList.map(renderOption)}
										>
											<Input
												style={{ width: "100%", height: 48, border: "1px solid #D9D9D9", borderRadius: "5px" }}
												placeholder="Enter New Phone Number"
												// type="number"
												maxLength={contactNumberLength}
												// onKeyPress={(e) => {
												// 	if (e.key < 0 && e.key > 9) {
												// 		e.preventDefault();
												// 	}
												// }}
											/>
										</AutoComplete>
									</div>
								</div>
							) : confirmPage === 2 ? (
								<>
									<RowDetails cardList={customerDetail?.card_list} phone={customerDetail?.contact_number} status="old" type={null} />
									<RowDetails cardList={[]} phone={updateNumber?.contact_number} status="new" type={"updateNumber"} />
								</>
							) : confirmPage === 1 ? (
								<div style={{ display: "flex", flexDirection: "column", marginTop: 16 }}>
									<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#181818" }}>
										We've sent an OTP to Customer's Phone Number
									</Text>
									<OtpInput
										value={otp}
										onChange={(otp) => setOTP(otp)}
										isInputNum={true}
										numInputs={6}
										containerStyle={{ margin: "16px 0" }}
										inputStyle={{ width: 69, height: 48, border: "1px solid #AAAAAA", boxSizing: "border-box", borderRadius: "4px" }}
										focusStyle={{ border: "1px solid #fec708" }}
										separator={<span style={{ marginRight: "12px" }}></span>}
									/>
									<Text
										onClick={() => sendOTP(updateNumberRef.current)}
										style={{
											fontStyle: "normal",
											fontWeight: "normal",
											fontSize: "14px",
											lineHeight: "22px",
											color: "#fec708",
											textAlign: "center",
											cursor: "pointer",
										}}>
										Resend OTP
									</Text>
								</div>
							) : (
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										background: "#FFFFFF",
										width: "100%",
										padding: 16,
										marginTop: 24,
									}}>
									<img
										src={changePhoneGif}
										style={{
											width: "160px",
											height: "160px",
											borderRadius: "100px",
										}}
										alt={"Illustration"}
									/>
									<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "32px", color: "#181818", marginTop: 16 }}>
										Phone Number has been changed successfully
									</Text>
									<Text
										style={{
											fontStyle: "normal",
											fontWeight: "normal",
											fontSize: "14px",
											lineHeight: "22px",
											marginTop: 16,
											textAlign: "center",
											padding: "0 76px",
										}}>
										Please inform customer that they must log out and log in to the Banat Al Nujoom App to view the changes.
									</Text>
								</div>
							)}
						</div>
						{confirmPage !== 1 && <Divider />}
						<Row
							style={{
								textAlign: confirmPage !== 3 ? "right" : "center",
							}}>
							{confirmPage !== 3 && confirmPage !== 1 && (
								<Button
									size="large"
									style={{
										height: "40px",
										boxShadow: "none",
										borderRadius: "5px",
										border: "none",
										backgroundColor: "#FFFFFF",
										color: "#181818",
										marginRight: "16px",
									}}
									onClick={() => {
										setUpdateNumberModal(false);
										setConfirmPage(0);
										setUpdateNumber(null);
									}}>
									Cancel
								</Button>
							)}
							{confirmPage !== 1 && (
								<Button
									disabled={(!updateNumber && confirmPage === 0) || disableBtn}
									size="large"
									style={{
										height: "40px",
										borderRadius: "5px",
										border: "none",
										backgroundColor: "#fec708",
										color: "#FFFFFF",

										opacity: (!updateNumber && confirmPage === 0) || disableBtn ? 0.4 : 1,
									}}
									onClick={() => {
										if (confirmPage === 0) {
											setConfirmPage(1);
										} else if (confirmPage === 2) {
											setDisableBtn(true);
											updateContactNumberApi({
												requestData: {
													old_contact_number: customerDetail?.contact_number,
													// old_country_code: "971",
													old_country_code: customerDetail?.country_code,
													new_contact_number: updateNumber?.contact_number,
													new_country_code: updateNumber?.country_code,
													// new_country_code: "971",
													old_card_details: [
														{
															card_no: customerDetail?.card_list[0]?.card_no,
															points: parseFloat(customerDetail?.card_list[0]?.points.toFixed(2)),
														},
													],
													new_card_details: [
														{
															card_no: customerDetail?.card_list[0]?.card_no,
															points: parseFloat(customerDetail?.card_list[0]?.points.toFixed(2)),
														},
													],
													new_points: parseFloat(customerDetail?.card_list[0]?.points.toFixed(2)),
												},
												resCallback: () => setDisableBtn(false),
												res200Callback: () => {
													setConfirmPage(3);
													message.success("Contact Number Updated Successfully.");
													setUpdateNumber(null);
												},
											});
										} else {
											props.history.go(-1);
										}
									}}>
									{confirmPage === 0 ? "Continue" : confirmPage === 2 ? "Confirm Update" : "Back to Home"}
								</Button>
							)}
						</Row>
					</Row>
				</Row>
			</Modal>
			<Modal
				width={mergeConfirmPage === 0 ? 450 : mergeConfirmPage === 1 ? 522 : mergeConfirmPage === 2 ? 580 : 660}
				centered
				visible={mergeNumberModal}
				closable={mergeConfirmPage !== 3}
				destroyOnClose
				maskClosable={false}
				onCancel={() => {
					setDisableBtn(false);
					setMergeNumberModal(false);
					setMergeConfirmPage(0);
					setMergeNumber(null);
				}}
				footer={null}>
				<Row className="modal-row">
					{mergeConfirmPage !== 3 && (
						<Row type="flex" align="middle">
							<img
								src={mergeContactsSmall}
								style={{
									width: "32px",
									height: "32px",
									marginRight: 16,
								}}
								alt={"Illustration"}
							/>
							<Text
								style={{
									fontWeight: "bold",
									color: "#181818",
									fontSize: "24px",
								}}>
								{mergeConfirmPage === 0 ? "Merge" : mergeConfirmPage === 1 ? "Verify" : mergeConfirmPage === 2 ? "Confirm" : "Merged"} Phone Number
							</Text>
						</Row>
					)}
					{mergeConfirmPage !== 3 && <Divider />}
					<Row style={{ marginTop: "24px" }}>
						<div>
							{mergeConfirmPage !== 3 && (
								<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
									Please note that the old number entered will be merged to the new number along with points of the card attached with new number will
									be transfered to the card attached with old number.
								</Text>
							)}
							{mergeConfirmPage === 0 ? (
								<div style={{ display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 16 }}>
									<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "14px", lineHeight: "22px", color: "#181818" }}>
										New Phone Number
									</Text>
									<div style={{ display: "flex", alignItems: "center" }}>
										<Select
											showSearch
											allowClear
											style={{
												display: "flex",
												alignItems: "center",
												margin: "16px 16px 0 0",
												// padding: "8px 8px",
												justifyContent: "space-between",
												width: 200,
												border: "1px solid #D9D9D9",
												borderRadius: "5px",
												height: "48px",
												textOverflow: "ellipsisis",
											}}
											defaultValue={countryCode}
											placeholder="Country Code"
											optionFilterProp="children"
											onChange={(value) => setCountryCode(value)}
											disabled={true}
											filterOption={(input, option) => option.props.children.indexOf(input) >= 0}>
											{countryList.map((country) => (
												<Option key={country.phone} value={country.phone}>
													{country.emoji} {`${country.shortName} (+${country.phone})`}
												</Option>
											))}
										</Select>
										<AutoComplete
											dropdownStyle={{ width: 250, border: "1px solid #D9D9D9", borderRadius: "5px" }}
											size="large"
											style={{ width: "100%", height: 48, marginTop: 16 }}
											onSearch={(str) => {
												mergeNumberRef.current = str;
												str.length === contactNumberLength
													? str !== customerDetail.contact_number
														? fetchLscCustomer({
																requestData: {
																	country_code: countryCode,
																	contact_number: mergeNumberRef.current,
																},
																res200Callback: (res) => {
																	if (res.data.account_exists) {
																		res.data.card_list?.length === 0
																			? message.warning("No Banat Al Nujoom Cards were found on this mobile number.")
																			: res.data.card_list?.length === 1
																			? message.info("This mobile number is eligible to merge.")
																			: message.warning(
																					"We found multiple Banat Al Nujoom Cards on this phone number. Please first merge all Banat Al Nujoom Cards before proceeding."
																			  );

																		setMergeNumber({ ...res.data });
																	} else {
																		message.warning("No such user exist, please proceed to change phone number.");
																	}
																},
																resErrorCallback: () => {
																	message.error("No such number exist to merge with, ask user to login in Banat Al Nujoom using this number.");
																},
														  })
														: message.error("The number entered cannot be same as the customer's current number")
													: setMergeNumber(null);
											}}
											optionLabelProp="value"
											// dataSource={customerList.map(renderOption)}
										>
											<Input
												style={{ width: "100%", height: 48, border: "1px solid #D9D9D9", borderRadius: "5px" }}
												placeholder="Enter New Phone Number"
												// type="number"
												maxLength={contactNumberLength}
												// onKeyPress={(e) => {
												// 	if (e.key < 0 && e.key > 9) {
												// 		e.preventDefault();
												// 	}
												// }}
											/>
										</AutoComplete>
									</div>
									{!!mergeNumber && verifiedCustomer && (
										<>
											<Divider />
											<Row type="flex" align="middle">
												<img
													src={avatarMed}
													style={{
														width: "80px",
														height: "80px",
														marginRight: "16px",
													}}
													alt={"Illustration"}
												/>
												<div style={{ display: "flex", flexDirection: "column" }}>
													<Text style={{ fontSize: "24px", color: "#181818", fontWeight: "bold", lineHeight: "40px" }}>
														{mergeNumber.name !== undefined && mergeNumber.name !== null ? mergeNumber.name : "-"}
													</Text>
													<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
														{mergeNumber.contact_number}
													</Text>
												</div>
											</Row>
											<Row style={{ marginTop: 20 }}>
												{mergeNumber.card_list?.map((card) => (
													<CardDetails cardNumber={card.card_no} cardPoints={card.points} />
												))}
												{mergeNumber.card_list?.length !== 1 && (
													<div style={{ width: "100%", background: "rgba(245, 34, 45, 0.1)", color: "#F5222D", padding: "8px 16px", marginTop: 16 }}>
														{mergeNumber.card_list?.length > 1 &&
															"We found multiple Banat Al Nujoom Cards on this phone number. Please first merge all Banat Al Nujoom Cards before proceeding."}
														{mergeNumber.card_list?.length === 0 &&
															"No Banat Al Nujoom Cards found on this phone number. Ask Customer to login to Banat Al Nujoom App using this number before proceeding."}
													</div>
												)}
											</Row>
										</>
									)}
								</div>
							) : mergeConfirmPage === 2 ? (
								<>
									<RowDetails cardList={customerDetail?.card_list} phone={customerDetail?.contact_number} status="old" type={null} />
									<RowDetails cardList={mergeNumber?.card_list} phone={mergeNumber?.contact_number} status="new" type={"mergeNumber"} />
								</>
							) : mergeConfirmPage === 1 ? (
								<div style={{ display: "flex", flexDirection: "column", marginTop: 16 }}>
									<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#181818" }}>
										We've sent an OTP to Customer's Phone Number
									</Text>
									<OtpInput
										value={otp}
										onChange={(otp) => setOTP(otp)}
										isInputNum={true}
										numInputs={6}
										containerStyle={{ margin: "16px 0" }}
										inputStyle={{ width: 69, height: 48, border: "1px solid #AAAAAA", boxSizing: "border-box", borderRadius: "4px" }}
										focusStyle={{ border: "1px solid #fec708" }}
										separator={<span style={{ marginRight: "12px" }}></span>}
									/>
									<Text
										onClick={() => sendOTP(mergeNumberRef.current)}
										style={{
											fontStyle: "normal",
											fontWeight: "normal",
											fontSize: "14px",
											lineHeight: "22px",
											color: "#fec708",
											textAlign: "center",
											cursor: "pointer",
										}}>
										Resend OTP
									</Text>
								</div>
							) : (
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										background: "#FFFFFF",
										width: "100%",
										padding: 16,
										marginTop: 24,
									}}>
									<img
										src={mergePhoneGif}
										style={{
											width: "160px",
											height: "160px",
											borderRadius: "100px",
										}}
										alt={"Illustration"}
									/>
									<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "32px", color: "#181818", marginTop: 16 }}>
										Phone Number has been merged successfully
									</Text>
									<Text
										style={{
											fontStyle: "normal",
											fontWeight: "normal",
											fontSize: "14px",
											lineHeight: "22px",
											marginTop: 16,
											textAlign: "center",
											padding: "0 76px",
										}}>
										Please inform customer that they must log out and log in to the Banat Al Nujoom App to view the changes.
									</Text>
								</div>
							)}
						</div>
						{mergeConfirmPage !== 1 && <Divider />}
						<Row
							style={{
								textAlign: mergeConfirmPage !== 3 ? "right" : "center",
							}}>
							{mergeConfirmPage !== 3 && mergeConfirmPage !== 1 && (
								<Button
									size="large"
									style={{
										height: "40px",
										boxShadow: "none",
										borderRadius: "5px",
										border: "none",
										backgroundColor: "#FFFFFF",
										color: "#181818",
										marginRight: "16px",
									}}
									onClick={() => {
										setMergeNumberModal(false);
										setMergeConfirmPage(0);
										setMergeNumber(null);
									}}>
									Cancel
								</Button>
							)}
							{mergeConfirmPage !== 1 && (
								<Button
									disabled={!mergeNumber || mergeNumber?.card_list?.length !== 1 || disableBtn}
									size="large"
									style={{
										height: "40px",
										borderRadius: "5px",
										border: "none",
										backgroundColor: "#fec708",
										color: "#FFFFFF",

										opacity: !mergeNumber || mergeNumber?.card_list?.length !== 1 || disableBtn ? 0.4 : 1,
									}}
									onClick={() => {
										if (mergeConfirmPage === 0) {
											setMergeConfirmPage(verifiedCustomer ? 2 : 1);
										} else if (mergeConfirmPage === 2) {
											setDisableBtn(true);
											mergeCustomersApi({
												requestData: {
													old_country_code: customerDetail?.country_code,
													old_contact_number: customerDetail?.contact_number,
													new_country_code: mergeNumber?.country_code,
													new_contact_number: mergeNumber?.contact_number,
													new_card_details: [
														{
															card_no: mergeNumber?.card_list[0]?.card_no,
															points: parseFloat(mergeNumber?.card_list[0]?.points.toFixed(2)),
														},
													],
													old_card_details: [
														{
															card_no: customerDetail?.card_list[0]?.card_no,
															points: parseFloat((customerDetail?.card_list[0]?.points).toFixed(2)),
														},
													],
													new_points: parseFloat((customerDetail?.card_list[0]?.points + mergeNumber?.card_list[0]?.points).toFixed(2)),
												},
												resCallback: () => setDisableBtn(false),
												res200Callback: () => {
													message.success("Customers Merged Successfully.");
													// setMergeNumberModal(false);
													setMergeConfirmPage(3);
													setMergeNumber(null);
												},
											});
										} else {
											props.history.go(-1);
										}
									}}>
									{mergeConfirmPage === 0 ? "Continue" : mergeConfirmPage === 2 ? "Confirm Merge" : "Back to Home"}
								</Button>
							)}
						</Row>
					</Row>
				</Row>
			</Modal>
			<Modal
				width={assignConfirmPage === 0 ? 450 : assignConfirmPage === 1 ? 522 : assignConfirmPage === 2 ? 580 : 660}
				centered
				visible={assignCardModal}
				closable={assignConfirmPage !== 3}
				destroyOnClose
				maskClosable={false}
				onCancel={() => {
					setAssignCardModal(false);
					setAssignConfirmPage(0);
					setAssignNumber(null);
				}}
				footer={null}>
				<Row className="modal-row">
					{assignConfirmPage !== 3 && (
						<Row type="flex" align="middle">
							<img
								src={assignCardSmall}
								style={{
									width: "32px",
									height: "32px",
									marginRight: 16,
								}}
								alt={"Illustration"}
							/>
							<Text
								style={{
									fontWeight: "bold",
									color: "#181818",
									fontSize: "24px",
								}}>
								{assignConfirmPage === 0
									? "Assign Card"
									: assignConfirmPage === 1
									? "Assign Card to"
									: assignConfirmPage === 2
									? "Confirm Assign Card"
									: "Card Assigned"}
							</Text>
						</Row>
					)}
					{assignConfirmPage !== 3 && <Divider />}
					<Row style={{ marginTop: "24px" }}>
						<div>
							{/* {assignConfirmPage !== 3 && (
								<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
									Please note that the card linked with the old number will get linked to the new number once you proceed with this operation. The old
									number will not have any card(s) linked with it.
								</Text>
							)} */}
							{assignConfirmPage === 0 ? (
								<div style={{ display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 16 }}>
									<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "14px", lineHeight: "22px", color: "#181818" }}>
										New Phone Number
									</Text>
									<div style={{ display: "flex", alignItems: "center" }}>
										<Select
											showSearch
											allowClear
											style={{
												display: "flex",
												alignItems: "center",
												margin: "8px 16px 0 0",
												// padding: "8px 8px",
												justifyContent: "space-between",
												width: 200,
												border: "1px solid #D9D9D9",
												borderRadius: "5px",
												height: "48px",
												textOverflow: "ellipsisis",
											}}
											defaultValue={countryCode}
											placeholder="Country Code"
											optionFilterProp="children"
											onChange={(value) => setCountryCode(value)}
											disabled={true}
											filterOption={(input, option) => option.props.children.indexOf(input) >= 0}>
											{countryList.map((country) => (
												<Option key={country.phone} value={country.phone}>
													{country.emoji} {`${country.shortName} (+${country.phone})`}
												</Option>
											))}
										</Select>
										<AutoComplete
											dropdownStyle={{ width: 250, border: "1px solid #D9D9D9", borderRadius: "5px" }}
											size="large"
											style={{ width: "100%", height: 48, marginTop: 8 }}
											onSearch={(str) => {
												assignNumberRef.current = str;
												str.length === contactNumberLength
													? fetchLscCustomer({
															requestData: {
																country_code: countryCode,
																contact_number: assignNumberRef.current,
															},
															res200Callback: (res) => {
																if (res.data.account_exists) {
																	setAssignNumber({ ...res.data });
																} else {
																	setAssignNumber({ contact_number: assignNumberRef.current, card_list: [] });
																}
															},
															resErrorCallback: () => {
																setAssignNumber({ contact_number: assignNumberRef.current, card_list: [] });
															},
													  })
													: setAssignNumber(null);
											}}
											optionLabelProp="value"
											// dataSource={customerList.map(renderOption)}
										>
											<Input
												style={{ width: "100%", height: 48, border: "1px solid #D9D9D9", borderRadius: "5px" }}
												placeholder="Enter New Phone Number"
												maxLength={contactNumberLength}
											/>
										</AutoComplete>
									</div>
								</div>
							) : assignConfirmPage === 2 ? (
								<>
									<RowDetails cardList={customerDetail?.card_list} phone={null} status="old" type={null} />
									<RowDetails cardList={assignNumber?.card_list} phone={assignNumber?.contact_number} status="new" type={"assignNumber"} />
								</>
							) : // <Row type="flex" align="stretch" style={{ width: 760 }}>
							// 	{/* <RowDetails
							// 		cardNumber={customerDetail?.card_list[0]?.card_no}
							// 		cardPoints={customerDetail?.card_list[0]?.points.toFixed(2)}
							// 		phone={null}
							// 		status="old"
							// 	/> */}
							// 	<Row style={{ paddingRight: 64 }}>
							// 		<Row type="flex" gutter={[12, 12]} align="middle" style={{ marginTop: 16 }}>
							// 			<Col>
							// 				<img src={cardIllustrationBlack} style={{ width: "48px", height: "48px", paddingRight: 12 }} alt={"Illustration"} />
							// 			</Col>
							// 			<Col>
							// 				<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
							// 					Banat Al Nujoom Card Number
							// 				</Text>
							// 				<br />
							// 				<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
							// 					{customerDetail?.card_list[0]?.card_no !== undefined && customerDetail?.card_list[0]?.card_no !== null
							// 						? customerDetail?.card_list[0]?.card_no
							// 						: "-"}
							// 				</Text>
							// 			</Col>
							// 		</Row>
							// 		<Row type="flex" gutter={[12, 12]} align="middle" style={{ marginTop: 16 }}>
							// 			<Col>
							// 				<img src={pointsBlack} style={{ width: "48px", height: "48px", paddingRight: 12 }} alt={"Illustration"} />
							// 			</Col>
							// 			<Col>
							// 				<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
							// 					Total Points
							// 				</Text>
							// 				<br />
							// 				<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
							// 					{customerDetail?.card_list[0]?.points.toFixed(2) !== undefined && customerDetail?.card_list[0]?.points.toFixed(2) !== null
							// 						? customerDetail?.card_list[0]?.points.toFixed(2)
							// 						: "-"}
							// 				</Text>
							// 			</Col>
							// 		</Row>
							// 	</Row>
							// 	<Row type="flex" align="middle" style={{ paddingRight: 64 }}>
							// 		<img
							// 			src={transferArrow}
							// 			style={{
							// 				width: "32px",
							// 				height: "32px",
							// 				marginRight: 16,
							// 			}}
							// 			alt={"Illustration"}
							// 		/>
							// 	</Row>
							// 	<Row style={{ paddingRight: 64 }}>
							// 		<Row type="flex" gutter={[12, 12]} align="middle" style={{ marginTop: 16 }}>
							// 			<Col>
							// 				<img src={phoneGreen} style={{ width: "48px", height: "48px", paddingRight: 12 }} alt={"Illustration"} />
							// 			</Col>
							// 			<Col>
							// 				<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
							// 					Phone Number
							// 				</Text>
							// 				<br />
							// 				<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
							// 					{assignNumber?.contact_number !== undefined && assignNumber?.contact_number !== null ? assignNumber?.contact_number : "-"}
							// 				</Text>
							// 			</Col>
							// 		</Row>
							// 		{assignNumber?.card_list?.map((card) => (
							// 			<>
							// 				<Row type="flex" gutter={[12, 12]} align="middle" style={{ marginTop: 16 }}>
							// 					<Col>
							// 						<img src={cardIllustrationGreen} style={{ width: "48px", height: "48px", paddingRight: 12 }} alt={"Illustration"} />
							// 					</Col>
							// 					<Col>
							// 						<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
							// 							Banat Al Nujoom Card Number
							// 						</Text>
							// 						<br />
							// 						<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
							// 							{card?.card_no !== undefined && card?.card_no !== null ? card?.card_no : "-"}
							// 						</Text>
							// 					</Col>
							// 				</Row>
							// 				<Row type="flex" gutter={[12, 12]} align="middle" style={{ marginTop: 16 }}>
							// 					<Col>
							// 						<img src={pointsGreen} style={{ width: "48px", height: "48px", paddingRight: 12 }} alt={"Illustration"} />
							// 					</Col>
							// 					<Col>
							// 						<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
							// 							Total Points
							// 						</Text>
							// 						<br />
							// 						<Text style={{ fontSize: "16px", color: "#181818", fontWeight: "bold" }}>
							// 							{card?.points?.toFixed(2) !== undefined && card?.points?.toFixed(2) !== null ? card?.points?.toFixed(2) : "-"}
							// 						</Text>
							// 					</Col>
							// 				</Row>
							// 			</>
							// 		))}
							// 	</Row>
							// 	{/* <RowDetails
							// 		cardNumber={customerDetail?.card_list[0]?.card_no}
							// 		cardPoints={customerDetail?.card_list[0]?.points.toFixed(2)}
							// 		phone={assignNumber?.contact_number}
							// 		status="new"
							// 	/> */}
							// </Row>
							assignConfirmPage === 1 ? (
								<div style={{ display: "flex", flexDirection: "column", marginTop: 16 }}>
									<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#181818" }}>
										We've sent an OTP to Customer's Phone Number
									</Text>
									<OtpInput
										value={otp}
										onChange={(otp) => setOTP(otp)}
										isInputNum={true}
										numInputs={6}
										containerStyle={{ margin: "16px 0" }}
										inputStyle={{ width: 69, height: 48, border: "1px solid #AAAAAA", boxSizing: "border-box", borderRadius: "4px" }}
										focusStyle={{ border: "1px solid #fec708" }}
										separator={<span style={{ marginRight: "12px" }}></span>}
									/>
									<Text
										onClick={() => sendOTP(assignNumber.contact_number)}
										style={{
											fontStyle: "normal",
											fontWeight: "normal",
											fontSize: "14px",
											lineHeight: "22px",
											color: "#fec708",
											textAlign: "center",
											cursor: "pointer",
										}}>
										Resend OTP
									</Text>
								</div>
							) : (
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										background: "#FFFFFF",
										width: "100%",
										padding: 16,
										marginTop: 24,
									}}>
									<img
										src={assignCardLarge}
										style={{
											width: "160px",
											height: "160px",
											borderRadius: "100px",
										}}
										alt={"Illustration"}
									/>
									<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "32px", color: "#181818", marginTop: 16 }}>
										Card has been assigned successfully
									</Text>
									<Text
										style={{
											fontStyle: "normal",
											fontWeight: "normal",
											fontSize: "14px",
											lineHeight: "22px",
											marginTop: 16,
											textAlign: "center",
											padding: "0 76px",
										}}>
										Please inform customer that they must log out and log in to the Banat Al Nujoom App to view the changes.
									</Text>
								</div>
							)}
						</div>
						{assignConfirmPage !== 1 && <Divider />}
						<Row
							style={{
								textAlign: assignConfirmPage !== 3 ? "right" : "center",
							}}>
							{assignConfirmPage !== 3 && assignConfirmPage !== 1 && (
								<Button
									size="large"
									style={{
										height: "40px",
										boxShadow: "none",
										borderRadius: "5px",
										border: "none",
										backgroundColor: "#FFFFFF",
										color: "#181818",
										marginRight: "16px",
									}}
									onClick={() => {
										setAssignCardModal(false);
										setAssignConfirmPage(0);
										setAssignNumber(null);
									}}>
									Cancel
								</Button>
							)}
							{assignConfirmPage !== 1 && (
								<Button
									disabled={assignNumber?.contact_number?.length !== contactNumberLength || disableBtn}
									size="large"
									style={{
										height: "40px",
										borderRadius: "5px",
										border: "none",
										backgroundColor: "#fec708",
										color: "#FFFFFF",

										opacity: assignNumber?.contact_number?.length !== contactNumberLength || disableBtn ? 0.4 : 1,
									}}
									onClick={() => {
										if (assignConfirmPage === 0) {
											setAssignConfirmPage(1);
										} else if (assignConfirmPage === 2) {
											setDisableBtn(true);
											linkCardApi({
												requestData: {
													// old_contact_number: customerDetail?.contact_number,
													// old_country_code: "971",
													// old_country_code: customerDetail?.country_code,
													new_contact_number: assignNumber?.contact_number,
													// new_country_code: updateNumber?.country_code,
													country_code: countryCode,
													// old_card_details: [
													// 	{
													// 		inaam_card_number: customerDetail?.card_list[0]?.card_no,
													// 		points: parseFloat(customerDetail?.card_list[0]?.points.toFixed(2)),
													// 	},
													// ],
													card_no: customerID,
												},
												resCallback: () => setDisableBtn(false),
												res200Callback: () => {
													setAssignConfirmPage(3);
													message.success("Contact Number Assigned Successfully.");
													setUpdateNumber(null);
												},
											});
										} else {
											props.history.go(0);
										}
									}}>
									{assignConfirmPage === 0 ? "Continue" : assignConfirmPage === 2 ? "Confirm Update" : "Back to Home"}
								</Button>
							)}
						</Row>
					</Row>
				</Row>
			</Modal>
		</Row>
	);
};

export default CustomerDetail;
